// The shared half of every tool's table (unify-ui ship 3): the leaves two or more tools hold with
// the same words — deduped into the package, composed under each tool's own table by compose()
// (@3dp/ui/i18n); the tool's own table keeps what is its alone. Thai is today's wording, character
// for character (ruling R18). packages/ui/test/strings.test.js holds this file's shape; each tool's
// test/tables.test.js holds its composed table to English's key set, kinds and placeholders.
export const SHARED_TH = {
  back: "เครื่องมือ",   // the home link's word; its arrow is the template's (R70: at the phone layout the link shows the arrow alone, this word is its aria-label)
  text: "ข้อความ",
  font: "ฟอนต์",
  dl3mf: "ดาวน์โหลด 3MF",
  share: "คัดลอกลิงก์",
  updating: "กำลังคำนวณ…",
  exportFail: "ดาวน์โหลดไม่สำเร็จ",
  useFont: (family, mb) => `ใช้ ${family} (${mb} MB)`,
  pickFromList: "ฟอนต์อื่นในรายการฟอนต์อาจมีตัวอักษรเหล่านี้",   // R83: after the offered family, what it lacks — the list holds the others
  fontFailed: (family) => `โหลดฟอนต์ ${family} ไม่ได้ — ตรวจการเชื่อมต่อ · ใช้ฟอนต์เดิมต่อ`,
  fontNotOffered: (asked) => `ลิงก์นี้ใช้ฟอนต์ ${asked} ซึ่งหน้านี้ยังไม่มี — ใช้ Kanit แทน`,
  pick: "เลือกไฟล์ SVG",
  reading: "กำลังอ่านไฟล์…",
  notSvg: "รองรับเฉพาะไฟล์ SVG — ใน Illustrator เลือก Export As → SVG และแปลงตัวอักษรเป็น outline ก่อน",
  svgTooBig: "ไฟล์ใหญ่หรือละเอียดเกินไป — ลดจำนวนจุดหรือรวมรูปทรงให้น้อยลง แล้วส่งออกเป็น SVG ใหม่",
  svgEmpty: "ไม่พบรูปทรงที่มีสีเติมในไฟล์นี้ — แปลงเส้นและตัวอักษรเป็น outline ก่อน",
  svgBad: "อ่านไฟล์นี้ไม่ได้ — ไม่ใช่ไฟล์ SVG ที่ใช้ได้",
  readFail: "อ่านไฟล์ไม่สำเร็จ — ลองเลือกไฟล์อีกครั้ง",
  skipped: {
    background: (n) => `พื้นหลัง ${n} ชิ้น — ตัดออก`,
    bad: (n) => `รูปทรงที่อ่านไม่ได้ ${n} ชิ้น — ข้ามไป`,
    clipped: (n) => `รูปทรงที่มี clip หรือ mask ${n} ชิ้น — ใช้ทั้งรูปทรง ไม่ตัดตาม clip`,
    hidden: (n) => `ส่วนที่ซ่อนอยู่ ${n} ชิ้น — ไม่ได้นำมาใช้`,
    image: (n) => `รูปภาพ ${n} ชิ้น — ใช้ได้เฉพาะรูปทรงเวกเตอร์`,
    stroke: (n) => `เส้นที่ไม่มีสีเติม ${n} ชิ้น — แปลงเส้นเป็น outline ก่อน`,
    stroked: (n) => `รูปทรงที่มีเส้นขอบ ${n} ชิ้น — ไม่รวมความหนาของเส้นขอบ`,
    text: (n) => `ข้อความ ${n} ชิ้น — แปลงเป็น outline ก่อน`,
  },
  badLink: "ลิงก์นี้ใช้ไม่ได้ — เปิดแบบเริ่มต้นแทน",
  newerLink: "ลิงก์นี้มาจากเวอร์ชันใหม่กว่า — เปิดแบบเริ่มต้นแทน",
  buildFail: "คำนวณแบบไม่สำเร็จ — ลองปรับค่าอีกครั้ง",
  lineHint: "เปิดในเบราว์เซอร์เพื่อดาวน์โหลด",
  shareNoLogo: "ลิงก์นี้ไม่มีไฟล์โลโก้ — ผู้รับต้องเลือกไฟล์ SVG เอง",
  linkNeedsLogo: "แบบนี้ใช้โลโก้จากไฟล์ ซึ่งไม่ได้มากับลิงก์ — เลือกไฟล์ SVG เพื่อใส่โลโก้",
  h: "สูง (มม.)",
  numHint: (lo, hi) => `ใส่ตัวเลข ${lo}–${hi}`,
  percent: (v) => `${Math.round(v * 100)}%`,
  slot: (n) => `ช่อง ${n}`,
  parts: {
    lid: "ฝา",
  },
  fits: {
    loose: "หลวม",
  },
  finishes: {
    engraved: "เซาะร่อง",
  },
  lookNames: {
    filasophy: "Filasophy",
  },
  viewGroup: "มุมมอง",
  sources: {
    none: "ไม่มี",
    svg: "ไฟล์ SVG",
    text: "ข้อความ",
  },
  mood: {
    all: "ทั้งหมด",
    bold: "หนา",
    cute: "น่ารัก",
    handwritten: "ลายมือ",
    neat: "เรียบร้อย",
    tech: "เทคโนโลยี",
  },
  problem: {
    "missing-chars": (p) => `ฟอนต์นี้ไม่มีตัวอักษร ${p.chars.slice(0, 12).join(' ')}`,
    "text-too-complex": "ข้อความละเอียดเกินไป — ลองลดตัวอักษรหรือเปลี่ยนฟอนต์ ดาวน์โหลดไม่ได้",
  },
  noGl: "เบราว์เซอร์นี้แสดงภาพ 3 มิติไม่ได้ แต่ยังดาวน์โหลดไฟล์ได้",
  needFileLine: "ใน LINE ดาวน์โหลดไม่ได้ — เปิดหน้านี้ในเบราว์เซอร์ก่อน แล้วค่อยเลือกไฟล์",
  machineNote: null,   // the ja/zh-CN/zh-TW tables carry the "machine-written, unread" line; en/th render nothing

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  undo: "ย้อนกลับ",
  redo: "ทำซ้ำ",
  // ship 3 piece f (ruling R21): the language switch, its cannot-carry note, and the English-page offer
  langSwitchLabel: "ภาษา",
  switchNoFile: "ลิงก์ไม่มีไฟล์ที่อัปโหลด — ต้องเลือกไฟล์ใหม่หลังเปลี่ยนภาษา",
  offerLine: "ดูหน้านี้เป็นภาษาไทย",
  offerDismiss: null,
  // the font control and the font sheet (@3dp/ui font-control.js, picker.js — unify-ui ship 4a, moved from name-tag)
  pickFont: "เลือกฟอนต์",
  close: "ปิด",
  weight: "น้ำหนักตัวอักษร",
  weightName: (w) => `${w} ${{ 100: 'บางพิเศษ', 200: 'บางมาก', 300: 'บาง', 400: 'ปกติ', 500: 'กลาง', 600: 'ค่อนข้างหนา', 700: 'หนา', 800: 'หนามาก', 900: 'หนาพิเศษ' }[w] || ''}`.trim(),
  scriptName: {
    latin: "อังกฤษ",
    thai: "ไทย",
    japanese: "ญี่ปุ่น",
    "chinese-simplified": "จีนตัวย่อ",
    "chinese-traditional": "จีนตัวเต็ม",
    han: "จีน/ญี่ปุ่น",
    other: "ภาษาอื่น",
  },
  chipRemove: "แสดงฟอนต์ทุกภาษา",
  chipMark: "×",
  noFontForText: "ไม่มีฟอนต์ที่รองรับข้อความนี้ — ลองภาษาอื่น",
  noFontInMood: "ไม่มีฟอนต์ในหมวดนี้",
  fontLoadFailed: "โหลดไม่ได้ — ตรวจการเชื่อมต่อ",
  sample: {
    japanese: "名札",
    "chinese-simplified": "名牌",
    "chinese-traditional": "名牌",
  },
  moreFonts: "ฟอนต์เพิ่มเติม (Google Fonts)",
  backToCurated: "← ฟอนต์แนะนำ",
  searchFonts: "ค้นหาฟอนต์",
  category: {
    all: "ทั้งหมด",
    "sans-serif": "ไม่มีเชิง",
    serif: "มีเชิง",
    display: "ตกแต่ง",
    handwriting: "ลายมือ",
    monospace: "ความกว้างเท่ากัน",
  },
  untested: "ยังไม่ได้ทดสอบการพิมพ์",
  noFontFound: "ไม่พบฟอนต์ — ลองคำอื่นหรือหมวดอื่น",
  catalogLoading: "กำลังโหลดรายชื่อฟอนต์…",
  catalogFailed: "โหลดรายชื่อฟอนต์ไม่ได้ — ตรวจการเชื่อมต่อ",
  mb: (mib) => `${mib.toFixed(1)} MB`,
  // the colour control (@3dp/ui colours.js — unify-ui ship 4b, moved from name-tag): the own-colour input, an own colour's caption
  customColor: "กำหนดเอง…",
  customCaption: "กำหนดเอง",
};
